import Datepicker, { DatepickerType } from "react-tailwindcss-datepicker";

const TGDatePicker = (props: DatepickerType) => {
  return (
    <Datepicker
      useRange={false}
      displayFormat="DD.MM.YYYY"
      placeholder="Укажите даты"
      i18n="ru"
      readOnly={true}
      primaryColor="blue"
      startWeekOn={"mon"}
      containerClassName="-translate-x-5"
      inputClassName={(p) => p + " translate-x-5"}
      {...props}
    />
  );
};

export default TGDatePicker;
